import { Image, StyledFlex, Tooltip } from '@tryhackme/thm-ui-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faDownload } from '@fortawesome/pro-regular-svg-icons';
import { faShare } from '@fortawesome/free-solid-svg-icons';
import certificateImg from 'src/images/pngs/certifications/cert.png';
import professionalCertificateImg from 'src/images/pngs/certifications/professional-cert.png';
import { ShareCertificateModal } from 'src/features/certificate-page/components';
import { useTrackEventMutation } from 'src/common/slices/analytics';
import { ensurePdfExtension } from 'src/common/helpers';
import { CertificateItemList } from '../certificates.types';
import { StyledButtonsWrapper, StyledCertificateButton, StyledCertificateCard, StyledContent, StyledDate, StyledImageWrapper, StyledTooltip, StyledWrapperButton } from './certificate-item.styles';
export const CertificateItem = ({
  isProfessionalCert,
  name,
  achieved,
  certId,
  url
}: CertificateItemList) => {
  const [trackEvent] = useTrackEventMutation();
  const handleCertificateDownload = () => {
    const urlPDF = ensurePdfExtension(url);
    window.open(urlPDF, '_blank');
  };
  const trackShareCertificate = () => {
    // eslint-disable-next-line no-void
    void trackEvent({
      event: 'view-cert',
      properties: {
        'page-referrer': 'path',
        name,
        certificate_type: 'certificate of completion'
      }
    });
  };
  const date = new Date(achieved);
  const formattedDate = date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  return <StyledCertificateCard data-testid="certificate" data-sentry-element="StyledCertificateCard" data-sentry-component="CertificateItem" data-sentry-source-file="certificate-item.tsx">
      <StyledFlex justifyContent="flex-start" alignItems="center" data-sentry-element="StyledFlex" data-sentry-source-file="certificate-item.tsx">
        <StyledImageWrapper data-sentry-element="StyledImageWrapper" data-sentry-source-file="certificate-item.tsx">
          <Image src={isProfessionalCert ? professionalCertificateImg : certificateImg} alt="certificate" data-sentry-element="Image" data-sentry-source-file="certificate-item.tsx" />
        </StyledImageWrapper>

        <StyledContent data-sentry-element="StyledContent" data-sentry-source-file="certificate-item.tsx">
          <h3>{name}</h3>
          <p>{isProfessionalCert ? 'Professional certificate' : 'Certificate of completion'}</p>
          <StyledDate dateTime={achieved.toString()} data-sentry-element="StyledDate" data-sentry-source-file="certificate-item.tsx">
            <FontAwesomeIcon icon={faCalendar} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="certificate-item.tsx" /> Issued on {formattedDate}
          </StyledDate>
        </StyledContent>
      </StyledFlex>

      <StyledButtonsWrapper alignItems="flex-start" gap="0.8rem" justifyContent="flex-end" data-sentry-element="StyledButtonsWrapper" data-sentry-source-file="certificate-item.tsx">
        <ShareCertificateModal dateIssued={achieved.toString()} url={ensurePdfExtension(url)} imageUrl={ensurePdfExtension(url)} certId={certId} name={name} modalBtn={<StyledCertificateButton variant="outlined" color="secondary" data-testid="share-certificate-btn" data-type="share" onClick={trackShareCertificate}>
              <FontAwesomeIcon icon={faShare} />
              Share certificate
            </StyledCertificateButton>} data-sentry-element="ShareCertificateModal" data-sentry-source-file="certificate-item.tsx" />

        <StyledWrapperButton data-sentry-element="StyledWrapperButton" data-sentry-source-file="certificate-item.tsx">
          <StyledCertificateButton data-testid="download-btn" variant="outlined" color="secondary" onClick={handleCertificateDownload} data-type="download" data-sentry-element="StyledCertificateButton" data-sentry-source-file="certificate-item.tsx">
            <FontAwesomeIcon icon={faDownload} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="certificate-item.tsx" />
          </StyledCertificateButton>
          <StyledTooltip data-section="tooltip" data-sentry-element="StyledTooltip" data-sentry-source-file="certificate-item.tsx">
            <Tooltip arrowPosition="bottom-center" data-sentry-element="Tooltip" data-sentry-source-file="certificate-item.tsx">Download</Tooltip>
          </StyledTooltip>
        </StyledWrapperButton>
      </StyledButtonsWrapper>
    </StyledCertificateCard>;
};